import { MouseEvent, useCallback, useState } from 'react'
import { PopoverState } from '../typings'

export function usePopoverState(): PopoverState {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const onOpen = useCallback((e: MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget || e.target)
  }, [])

  const onClose = useCallback(() => setAnchorEl(null), [])

  const open = Boolean(anchorEl)

  return {
    anchorEl,
    open,
    onOpen,
    onClose,
  }
}
